import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconImax24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="IMAX">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.5737 20.8191C23.3065 21.0062 22.9648 21.0513 22.6583 20.9398L20.2018 20.0465C14.9037 18.1199 9.09635 18.1199 3.79817 20.0465L1.34174 20.9398C1.03517 21.0513 0.693493 21.0062 0.426302 20.8191C0.159113 20.6319 5.35499e-08 20.3262 7.94757e-08 20L-5.56269e-07 3.99999C-5.30343e-07 3.67378 0.159112 3.36807 0.426301 3.18093C0.693492 2.99378 1.03517 2.94872 1.34174 3.0602L3.79817 3.95345C9.09634 5.88006 14.9037 5.88006 20.2018 3.95345L22.6583 3.0602C22.9648 2.94872 23.3065 2.99378 23.5737 3.18093C23.8409 3.36807 24 3.67378 24 3.99999L24 20C24 20.3262 23.8409 20.6319 23.5737 20.8191ZM22 18.5723L22 5.42769L20.8853 5.83303C15.1456 7.92019 8.85437 7.92019 3.11468 5.83303L2 5.42769L2 18.5723L3.11468 18.167C8.85437 16.0798 15.1456 16.0798 20.8853 18.167L22 18.5723Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
